export class DxStatusCodes {

    static ok = { "status": "200", "statusText": "OK"}
    static created = { "status": "201", "statusText": "Created"}
    static badRequest = { "status": "400", "statusText": "Bad Request" }
    static notFound = { "status": "404", "statusText": "Not Found" }
    static conflict = { "status": "409", "statusText": "Conflict" }
    static invalidData = { "status": "498", "statusText": "Dx Invalid Data" }
    static clientError = { "status": "499", "statusText": "Dx Client Error" }
    static internalServerError = { "status": "500", "statusText": "Internal Server Error" }

    static isOK(rhs) { return rhs && rhs.status && rhs.status === DxStatusCodes.ok.status ? true : false }
    static isCreated(rhs) { return rhs && rhs.status && rhs.status === DxStatusCodes.created.status ? true : false }
    static isBadRequest(rhs) { return rhs && rhs.status && rhs.status === DxStatusCodes.badRequest.status ? true : false }
    static isNotFound(rhs) { return rhs && rhs.status && rhs.status === DxStatusCodes.notFound.status ? true : false }
    static isConflict(rhs)  { return rhs && rhs.status && rhs.status === DxStatusCodes.conflict.status ? true : false }
    static isInvalidData(rhs) { return rhs && rhs.status && rhs.status === DxStatusCodes.invalidData.status ? true : false }
    static isClientError(rhs)  { return rhs && rhs.status && rhs.status === DxStatusCodes.clientError.status ? true : false }
    static isInternalServerError(rhs)  { return rhs && rhs.status && rhs.status === DxStatusCodes.internalServerError.status ? true : false }
    
    static throwBadRequest()  { throw DxStatusCodes.badRequest }
    static throwNotFound()  { throw DxStatusCodes.notFound }
    static throwConflict()  { throw DxStatusCodes.conflict }
    static throwInvalidData(message = '') { 
        const err = { ...DxStatusCodes.invalidData, message };
        throw err;
    }
    static throwClientError(message = '') {
        const err = { ...DxStatusCodes.clientError, message };
        throw err;
    }
    static throwInternalServerError()  { throw DxStatusCodes.internalServerError }
}

export default DxStatusCodes
